export default {
    props: {
        editableMode: {
            type: String,
            kComposite: 'editable.mode'
        }, 
        editableMove: {
            type: Boolean,
            kComposite: 'editable.move'
        }, 
        editableTemplate: {
            type: String | Function,
            kComposite: 'editable.template'
        }, 
        editableWindow: {
            type: Object,
            kComposite: 'editable.window'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Editable.js